import { GuideRequestPayload, LeadRequestPayload, LeadRequestResponse } from "./leadRequestApi.types";

export class LeadRequestApiError extends Error {
  constructor(public errors: string[] = []) {
    super("Lead request failed");
  }
}

// Public, unauthenticated lead capture for the signed-out landing and pricing pages. Nothing is
// stored: the enquiry is emailed to sales and acknowledged to the visitor.
export const submitLeadRequest = (payload: LeadRequestPayload) => post("/lead_requests", payload);

// The guide download form. The PDF is emailed to the visitor, never linked.
export const submitGuideRequest = (payload: GuideRequestPayload) => post("/guide_requests", payload);

async function post(path: string, payload: unknown): Promise<LeadRequestResponse> {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  const response = await fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));

  // Rack::Attack answers a throttled POST with a single `error`, not the model's `errors` list.
  // Without this a rate-limited visitor is told to check their connection.
  if (!response.ok) throw new LeadRequestApiError(data.errors ?? (data.error ? [data.error] : []));
  return data;
}
